export const iconFontAwesomeLogisticsRoadLock = (
	<i className="fa-solid fa-road-lock"></i>
);
